<div
  class="p-4 pt-2 md:pt-4 lg:p-10 flex-1 flex flex-col"
  [ngClass]="{
    'mobile-login gap-3': isMobileLogin
  }"
>
  <div class="hidden md:flex items-center justify-end gap-6">
    <span class="font-efSans-primary"></span>
    <span class="font-efSans-primary" *ngIf="registrationEnabled">
      <T
        str="Don't have an account yet?"
        key="customerPortal.kc.login.top-bar.register-label"
        tags="kc-forms, 3.1"
      ></T
    ></span>
    <a [href]="viewData.registrationUrl" *ngIf="registrationEnabled">
      <button
        data-cy="registration-button"
        class="revolution ef-branding"
        mat-button
        mat-stroked-button
        color="secondary"
      >
        <a>
          <T
            str="Register"
            key="customerPortal.kc.register.button"
            tags="kc-forms, 3.1"
          ></T>
        </a>
      </button>
    </a>
    <!-- <customer-portal-kc-localization-menu class="localizationMenu"></customer-portal-kc-localization-menu> -->
  </div>
  <div
    class="welcome flex flex-col gap-2 md:gap-6 pt-2 pb-2 md:pt-6"
    [ngClass]="{ 'pt-4': isMobileLogin }"
  >
    <div
      class="font-efSans-secondary font-semibold uppercase"
      *ngIf="!isMobileLogin"
    >
      {{ 'customer-portal' | sharedTranslate }}
    </div>
    <div
      class="font-canelablack text-2xl md:text-5xl md:max-w-[600px]"
      [ngClass]="{
        'text-white': isMobileLogin,
        'text-mat-ef-revolution-primary-500': !isMobileLogin
      }"
      [innerHTML]="getTitleTranslation() | safeHtml"
    ></div>
    <div
      *ngIf="hasSlogan"
      class="slogan font-efSans text-lg md:text-xl font-light"
      [ngClass]="{
        'text-white': isMobileLogin,
        'text-mat-ef-revolution-primary-500': !isMobileLogin
      }"
    >
      <!-- prettier-ignore -->
      {{ 'Emil Frey Key Ring - A Portal. Unlimited possibilities.' | translate:{ _key: 'customerPortal.kc.' + sloganTranslation, _tags: 'kc-forms, 3.1, notranslate'} }}
    </div>
    <div
      *ngIf="!isMobileLogin"
      class="font-efSans text-lg md:text-xl font-light mt-4"
    >
      <!-- prettier-ignore -->
      {{'I already have an account' | translate:{ _key: 'customerPortal.kc.login.subtitle', _tags: 'kc-forms, 3.1'} }}
    </div>
  </div>

  <customer-portal-kc-message></customer-portal-kc-message>

  <div class="login-form w-full lg:w-1/2 pb-4 md:pb-6 flex-1">
    <form
      class="flex flex-col gap-2 md:gap-3 revolution-form"
      #loginForm
      [formGroup]="form"
      method="POST"
      [action]="viewData.loginAction"
      (ngSubmit)="login()"
    >
      <mat-form-field class="email">
        <mat-label>
          {{ 'email' | sharedTranslate }}
        </mat-label>
        <mat-icon matPrefix svgIcon="alternate_email"></mat-icon>
        <input
          class="input"
          matInput
          required
          formControlName="email"
          name="username"
        />
        <mat-icon
          *ngIf="form.controls.email.touched && form.controls.email.invalid"
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.email.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.email,
              'customerPortal.kc.login.email.error.',
              {
                errKey: {
                  pattern: 'enter-valid-email',
                  email: 'enter-valid-email'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="password">
        <mat-label>
          {{ 'password' | sharedTranslate }}
        </mat-label>
        <mat-icon matPrefix svgIcon="vpn"></mat-icon>
        <input
          [type]="showPassword ? 'text' : 'password'"
          class="input"
          matInput
          type="password"
          required
          minlength="8"
          formControlName="password"
          name="password"
        />
        <mat-icon
          *ngIf="
            form.controls.password.touched && form.controls.password.invalid
          "
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-icon
          *ngIf="!showPassword"
          class="togglePasswordIcon"
          matSuffix
          svgIcon="visibility_off"
          (click)="toggleShowPassword()"
        >
        </mat-icon>
        <mat-icon
          *ngIf="showPassword"
          class="togglePasswordIcon"
          matSuffix
          svgIcon="visibility_on"
          (click)="toggleShowPassword()"
        >
        </mat-icon>
        <mat-error *ngIf="form.controls.password.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.password,
              'customerPortal.kc.login.password.error.',
              {
                num: 8,
                errKey: {
                  length: 'min-password-length',
                  minlength: 'min-password-length',
                  lowercase: 'password-lowercase-required',
                  uppercase: 'password-uppercase-required',
                  numeric: 'password-number-required',
                  invalid: 'password-invalid'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
      <mat-checkbox
        color="primary"
        class="remember hidden md:block"
        *ngIf="realmData.rememberMe"
        [checked]="isPwa || isMobile"
        name="rememberMe"
      >
        <T
          str="Remember me"
          key="customerPortal.kc.login.remember-me"
          tags="kc-forms, 3.1"
        ></T>
      </mat-checkbox>
      <input type="hidden" name="login" />
      <div
        class="buttons flex flex-col"
        [ngClass]="{
        'mt-3': isMobileLogin,
      }"
      >
        <button
          *ngIf="isMobileLogin"
          mat-button
          mat-stroked-button
          class="w-full py-2 revolution button-spinner submit-button"
          type="submit"
          [disabled]="!form.valid || loginStarted"
        >
          <ng-container *ngTemplateOutlet="loginButtonContent"> </ng-container>
        </button>
        <button
          *ngIf="!isMobileLogin"
          mat-button
          mat-raised-button
          color="secondary"
          class="w-full py-2 revolution button-spinner"
          type="submit"
          [disabled]="!form.valid || loginStarted"
        >
          <ng-container *ngTemplateOutlet="loginButtonContent"> </ng-container>
        </button>
        <div
          class="forgot-password pt-2 pb-3 md:pt-4 md:pb-4 flex justify-center text-sm font-semibold"
          (click)="cptGtmService.sendResetPasswordGtmData()"
          [ngClass]="{
            'text-white': isMobileLogin,
            'text-mat-ef-revolution-secondary-500': !isMobileLogin
          }"
        >
          <a [href]="viewData.loginResetCredentialsUrl">
            <T
              str="Forgot password"
              key="customerPortal.kc.login.forgot-password"
              tags="kc-forms, 3.1"
            ></T>
          </a>
        </div>
      </div>

      <ng-container *ngIf="registrationEnabled">
        <a
          *ngIf="isMobileLogin"
          mat-button
          mat-stroked-button
          class="w-full py-2 revolution inline-block md:hidden border-white text-white"
          [href]="viewData.registrationUrl"
        >
          <T
            str="Register"
            key="customerPortal.kc.register.button"
            tags="kc-forms, 3.1"
          ></T>
        </a>
        <a
          *ngIf="!isMobileLogin"
          mat-button
          mat-raised-button
          color="secondary"
          class="w-full py-2 revolution inline-block md:hidden"
          [href]="viewData.registrationUrl"
        >
          <T
            str="Register"
            key="customerPortal.kc.register.button"
            tags="kc-forms, 3.1"
          ></T>
        </a>
      </ng-container>
    </form>
  </div>
</div>

<ng-template #loginButtonContent>
  <customer-portal-ef-spinner
    [color]="isMobileLogin ? 'mat-ef-revolution-secondary' : 'mat-ef-revolution-grey-two-500'"
    [opacity]="0.7"
    [diameter]="16"
    *ngIf="loginStarted"
  >
  </customer-portal-ef-spinner>
  <T str="Login" key="customerPortal.kc.login.button" tags="kc-forms, 3.1"></T>
</ng-template>
